import { SlotTile } from "@/components/studio/SlotTile";

const SLOTS = ["large", "medium", "small"];

export const CollectionCard = ({ index, collection, scene, photos, onUpsert, onRemove }) => {
  const filled = SLOTS.filter((s) => photos.some((p) => p.collection === collection.id && p.slot === s)).length;
  return (
    <section data-testid={`collection-${collection.id}`} className="border border-[#1C1715]/10 bg-white p-6 sm:p-8">
      <div className="flex items-baseline justify-between gap-4">
        <div>
          <p className="eyebrow">Colección {index + 1}</p>
          <h2 className="mt-2 font-serif-display text-2xl text-[#1C1715]">{collection.title}</h2>
        </div>
        <span data-testid={`collection-${collection.id}-count`} className="text-xs text-[#8C827A] whitespace-nowrap">{filled} / 3 fotos</span>
      </div>
      {filled < 3 && <p className="mt-3 text-xs text-[#A67C52]">Faltan fotos: las placas vacías se verán en aluminio liso.</p>}
      <div className="mt-6 grid grid-cols-[1.6fr_0.8fr_0.8fr] items-start gap-3 sm:gap-4">
        {SLOTS.map((s) => (
          <SlotTile key={s} collectionId={collection.id} slot={s} panel={scene.panels[s]}
            photo={photos.find((p) => p.collection === collection.id && p.slot === s)} onUpsert={onUpsert} onRemove={onRemove} />
        ))}
      </div>
    </section>
  );
};
